/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiClientsMutationRequest,
  PostApiClientsMutationResponse,
} from '../models/PostApiClients.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiClientsMutationResponseSchema,
  postApiClientsMutationRequestSchema,
} from '../zod/postApiClientsSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiClientsMutationKey = () =>
  [{ url: '/api/clients' }] as const;

export type PostApiClientsMutationKey = ReturnType<
  typeof postApiClientsMutationKey
>;

/**
 * {@link /api/clients}
 */
export async function postApiClients(
  data: PostApiClientsMutationRequest,
  config: Partial<RequestConfig<PostApiClientsMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiClientsMutationRequestSchema.parse(data);
  const res = await request<
    PostApiClientsMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiClientsMutationRequest
  >({
    method: 'POST',
    url: `/api/clients`,
    data: requestData,
    ...requestConfig,
  });
  return postApiClientsMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/clients}
 */
export function usePostApiClients<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiClientsMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiClientsMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiClientsMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiClientsMutationKey();

  return useMutation<
    PostApiClientsMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiClientsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiClients(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
